var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExclamationMarkFilled = function SvgExclamationMarkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25c-4.825 0-8.75 3.925-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25Zm-.458 4.575h.9c.233 0 .425.192.416.425l-.133 5.35H9.267l-.134-5.35a.42.42 0 0 1 .417-.425h-.008Zm.458 8.35a.948.948 0 0 1-.958-.958.934.934 0 0 1 .958-.942c.508 0 .942.425.942.942 0 .516-.442.958-.942.958Z",
    fill: "current"
  })));
};
export default SvgExclamationMarkFilled;